import { PAGE_COUNTRY_MAP } from '@/src/constants/domain'

const SUPPORT_CARDS_DEFAULT_URL = 'https://ui.cltp.co/flyinstatic/common/themes/v2/img/support-cards.png'
const SUPPORT_CARDS_AR_URL = 'https://ui.cltp.co/flyinstatic/common/themes/v2/img/support-cards-ar.png'
const SUPPORT_CARDS_KSA_URL = 'https://ui.cltp.co/flyinstatic/common/themes/v2/img/support-cards-ksa.png'
const SUPPORT_CARDS_KSA_AR_URL = 'https://ui.cltp.co/flyinstatic/common/themes/v2/img/support-cards-ksa-ar.png'

type SupportCardsImageInput = {
    locale: string
    hostname?: string
}

export const getSupportCardsImageSrc = ({ locale, hostname }: SupportCardsImageInput): string => {
    const isArabic = locale.toLowerCase() === 'ar'
    // Any host on the KSA/global market gets the KSA cards — keyed off PAGE_COUNTRY_MAP so
    // QA hosts and sub-brands (me.flyin.com, heya.flyin.com) are covered, not just www.
    const isKsaHost = PAGE_COUNTRY_MAP[`https://${(hostname || '').toLowerCase()}`] === 'global'

    if (isKsaHost) {
        return isArabic ? SUPPORT_CARDS_KSA_AR_URL : SUPPORT_CARDS_KSA_URL
    }

    return isArabic ? SUPPORT_CARDS_AR_URL : SUPPORT_CARDS_DEFAULT_URL
}
